// @flow
import get from 'lodash/get';
import { getFullName, centsToDollars } from 'clark-utils';

import type { EngagementType } from 'types/engagements';
import type { SubjectsType, SubjectType } from 'types/subjects';
import type { ClientsType, ClientType } from 'types/clients';

type EngagementSubjectDetailsType = {
  subject: SubjectType,
  subjectName: string,
};

export const getEngagementSubjectDetails = (
  e: EngagementType,
  subjects: SubjectsType,
): EngagementSubjectDetailsType => {
  const subject = get(subjects, get(e, 'attributes.subjectId'));
  const subjectName = subject ? subject.attributes.name : 'Tutoring';

  return {
    subject,
    subjectName,
  };
};

type EngagementClientDetailsType = {
  client: ClientType,
  clientName: string,
  clientPath: string,
};

export const getEngagementClientDetails = (
  e: EngagementType,
  clients: ClientsType,
): EngagementClientDetailsType => {
  const relevantClientId = get(e, 'relationships.client.data.id');
  const client = clients[relevantClientId];
  const clientName = client ? getFullName(client.attributes) : 'Unknown Client';
  const clientPath = `/clients/${relevantClientId}`;

  return {
    client,
    clientName,
    clientPath,
  };
};

type EngagementDetailsType = {
  sessionLengthInHours: number,
  sessionWage: number,
  sessionWageInCents: number,
  hourlyWageInCents: number,
  hourlyWage: number,
};

export const getEngagementDetails = (e: EngagementType): EngagementDetailsType => {
  const hourlyWageInCents = e.attributes.tutorTakeHomeHourlyRateInCents;
  const hourlyWage = centsToDollars(hourlyWageInCents);

  const sessionLengthInHours = e.attributes.sessionLengthInMinutes / 60;

  const sessionWageInCents = hourlyWageInCents * sessionLengthInHours;
  const sessionWage = centsToDollars(sessionWageInCents);

  return {
    sessionLengthInHours,
    sessionWage,
    sessionWageInCents,
    hourlyWageInCents,
    hourlyWage,
  };
};



// WEBPACK FOOTER //
// ./src/utils/helpers/engagements/index.js